import styled from 'styled-components';

import COLORS from '../../../utils/colors.constants';

const Subtitle = styled.h2`
  margin-top: 20px;
  text-align: center;
  margin-bottom: 20px;
  color: ${COLORS.AZUL};
`;

export default Subtitle;
